/* nr-scroll-unlock-watchdog.js  -  FD26 launch safety net (2026-06-10).
   Symptom this guards against: page scroll frozen on iOS Safari because a
   scroll-lock class is stuck on <html>/<body> while no overlay is visible.
   Known writers of these classes: Focal drawers/modals (.lock-all,
   .lock-mobile), Klaviyo popups (klaviyo-prevent-body-scrolling).
   The watchdog only clears a lock after two consecutive checks find no
   visible overlay, so normal open/close transitions are never disturbed.
   Logs a console.warn whenever it has to intervene  -  if you see that
   warning during QA, there is still an upstream state bug to chase.
   Safe to remove post-season along with its include in layout/theme.liquid. */
(function () {
  if (window.__nrScrollUnlockWatchdog) return;
  window.__nrScrollUnlockWatchdog = true;

  function isVisible(el) {
    if (!el || !el.getClientRects().length) return false;
    var cs = window.getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.display !== 'none';
  }

  function anyVisible(selector) {
    var nodes = document.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) {
      if (isVisible(nodes[i])) return true;
    }
    return false;
  }

  function lockAllHasOwner() {
    if (document.documentElement.classList.contains('nr-search-panel-active')) return true;
    return anyVisible('#mobile-menu-drawer[open], #search-drawer[open], #mini-cart[open], modal-content[open], drawer-content[open], .pswp--open, .announcement-bar__content:not([hidden])');
  }

  function lockMobileHasOwner() {
    return anyVisible('popover-content[open], combo-box[open]');
  }

  function klaviyoLockHasOwner() {
    var nodes = document.querySelectorAll('[role="dialog"], [aria-modal="true"]');
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.id === 'mobile-menu-drawer' || node.id === 'search-drawer' || node.id === 'mini-cart') continue;
      if (isVisible(node)) return true;
    }
    return false;
  }

  var strikes = 0;

  function tick(force) {
    var html = document.documentElement;
    var body = document.body;
    var stuckLockAll = html.classList.contains('lock-all') && !lockAllHasOwner();
    var stuckLockMobile = html.classList.contains('lock-mobile') && !lockMobileHasOwner();
    var stuckKlaviyo = (body.classList.contains('klaviyo-prevent-body-scrolling') || html.classList.contains('klaviyo-prevent-body-scrolling')) && !klaviyoLockHasOwner();

    if (!stuckLockAll && !stuckLockMobile && !stuckKlaviyo) {
      strikes = 0;
      return;
    }

    strikes += 1;
    if (!force && strikes < 2) return;
    strikes = 0;

    if (stuckLockAll) html.classList.remove('lock-all');
    if (stuckLockMobile) html.classList.remove('lock-mobile');
    if (stuckKlaviyo) {
      body.classList.remove('klaviyo-prevent-body-scrolling');
      html.classList.remove('klaviyo-prevent-body-scrolling');
    }

    try {
      console.warn('[nr-scroll-watchdog] cleared stuck scroll lock', {
        lockAll: stuckLockAll,
        lockMobile: stuckLockMobile,
        klaviyo: stuckKlaviyo,
        path: window.location.pathname
      });
    } catch (error) { /* noop */ }
  }

  window.setInterval(function () { tick(false); }, 1000);

  /* iOS Safari back-forward cache restores the page exactly as it was  - 
     including a scroll lock that was applied when the user navigated away. */
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) tick(true);
  });
})();
